__webpack_require__.p = "/reports-tooltip-fix/referrals-hub/";